import { Input } from './Input';

// TODO: in v9, move styled() from Input.jsx to here
export var StyledInput = Input;